module.exports = require("watch-size");